// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoText_wrapper__-UGTF","noMarginTop":"InfoText_noMarginTop__Gsy1g","iconWrapper":"InfoText_iconWrapper__7sdoQ"};